import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { ButtonInline as ButtonInlineStyled } from './Button.styled';

const ButtonInline = forwardRef(function ButtonInline(
  { children, variant, tone, href, ...props },
  ref
) {
  const elAttrs = href ? { href, as: 'a' } : { type: 'button' };
  return (
    <ButtonInlineStyled ref={ref} $variant={variant} $tone={tone} {...elAttrs} {...props}>
      {children}
    </ButtonInlineStyled>
  );
});

export default ButtonInline;

ButtonInline.defaultProps = {
  variant: 'inline',
  tone: 'primary',
};

ButtonInline.propTypes = {
  /** Button content */
  children: PropTypes.node.isRequired,
  /** Defines the button overall layout */
  variant: PropTypes.oneOf([
    /** colorful with underline on hover/focus */
    'inline',
    /** shows underline by default */
    'underline',
  ]),
  /** Defines the button color scheme */
  tone: PropTypes.oneOf(['primary', 'inverted', 'subtle']),
  /** When provided it renders an anchor instead of button */
  href: PropTypes.string,
};
